import { getStoredUser } from "./authSession";

export function getUser() {
  return getStoredUser();
}
